module.exports = {"endpoint":"https://api.hkep.com/lrs/data/xAPI/","username":"0e15ff91b60653913b45935cde76a9f9cb2446d0","password":"a2363598fe21d5de6755e9f96b532800e08d070a","allowFail":false}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/json/xapi_config.json
// module id = lVGq
// module chunks = 2 3 4 5 6